// @flow
import Experiment from './components/Experiment/Experiment';
import ExperimentProvider from './components/Experiment/ExperimentProvider';
import {generateEvaluationData} from './testUtils';
import {evaluationIsVariant} from './utils';

import type {
    AbacusEvaluationData,
    AbacusEvaluatedTests,
    AbacusExperimentValue
} from './types';

export type {AbacusEvaluationData, AbacusEvaluatedTests, AbacusExperimentValue};

export default Experiment;
export {ExperimentProvider, generateEvaluationData, evaluationIsVariant};
